import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { FONT_FAMILY } from 'constants/font';
import { Row, Col, Text } from '@cuemath/comps';

const TextFont = styled(Text)`
  font-family: ${FONT_FAMILY};
`;

const Select = styled.select`
  width: 100%;
  height: 40px;
  font-size: 14px;
  background-color: ${({
    theme: {
      COLORS: { WHITE },
    },
  }) => WHITE};
  border-radius: 3px;
  border: 0.5px solid;
  padding: 5px 8px;
  border-color: ${({
    error,
    theme: {
      COLORS: { RED, PERIWINKLE_GRAY_DARK },
    },
  }) => (error ? RED : PERIWINKLE_GRAY_DARK)};
`;
const CustomRow = styled(Row)`
  & > :first-child {
    padding-left: 0;
  }
  & > :last-child {
    padding-right: 0;
  }
`;

export default class TimeInput extends PureComponent {
  static isValid(value) {
    const [hours = null, minutes = null] = value.split(':');

    return hours && minutes;
  }

  static propTypes = {
    selected: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    label: null,
    selected: '',
    onChange: () => {},
  };

  constructor(props) {
    super(props);

    this.hours = React.createRef();
    this.minutes = React.createRef();
  }

  onChange = () => {
    const { onChange } = this.props;

    if (onChange) {
      const hours = this.hours.current.value;
      const minutes = this.minutes.current.value;

      onChange(`${hours}:${minutes}`);
    }
  };

  render() {
    const { label, selected } = this.props;
    const [hours = '', minutes = ''] = selected.split(':');

    return (
      <Fragment>
        <TextFont>{label}</TextFont>
        <CustomRow>
          <Col auto>
            <div className="select-container">
              <Select ref={this.hours} value={hours} onChange={this.onChange} id="hours">
                <option disabled key={-1} value="">
                  Hours
                </option>
                {Array.from(Array(24).keys()).map(id => (
                  <option key={id} value={`0${id}`.slice(-2)}>
                    {id}
                  </option>
                ))}
              </Select>
            </div>
          </Col>
          <Col auto>
            <div className="select-container">
              <Select
                ref={this.minutes}
                value={minutes}
                onChange={this.onChange}
                id="minutes"
              >
                <option disabled key={-1} value="">
                  Minutes
                </option>
                {Array.from(Array(60).keys()).map(id => (
                  <option key={id} value={`0${id}`.slice(-2)}>
                    {id}
                  </option>
                ))}
              </Select>
            </div>
          </Col>
          <Col style={{ display: 'hidden' }} />
        </CustomRow>
      </Fragment>
    );
  }
}
